/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Why_People_Bid_DescriptionInputs */

const en_directory_vibebids_why_people_bid_description = /** @type {(inputs: Directory_Vibebids_Why_People_Bid_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One public board. One simple rule. Every screenshot of a bidding war brings the next visitor back to watch.`)
};

const zh_directory_vibebids_why_people_bid_description = /** @type {(inputs: Directory_Vibebids_Why_People_Bid_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个公开榜单，一条简单规则。每一张竞价截图，都会吸引下一位访客回来围观。`)
};

/**
* | output |
* | --- |
* | "One public board. One simple rule. Every screenshot of a bidding war brings the next visitor back to watch." |
*
* @param {Directory_Vibebids_Why_People_Bid_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_why_people_bid_description = /** @type {((inputs?: Directory_Vibebids_Why_People_Bid_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Why_People_Bid_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_why_people_bid_description(inputs)
	return zh_directory_vibebids_why_people_bid_description(inputs)
});
export { directory_vibebids_why_people_bid_description as "directory.vibebids.why_people_bid_description" }